import { all, call, put, takeEvery } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import {
  GET_ALL_FACTORY_OWNER,
  GET_ALL_FACTORY_LIST,
  GET_ALL_SPTF_CREATE,
  GET_SPTF_RECOVERY_REQUEST,
  UPDATE_SPTF_RECOVERY_REQUEST,
  DELETE_SPTF_RECOVERY_REQUEST,
  SEARCH_REQUEST,
} from "../../actionLabels";

import {
  FactoryOwnerListActionSuccess,
  FactoryOwnerListActionFail,
  FactoryListActionSuccess,
  FactoryListActionFail,
  createSptfActionSuccess,
  createEditApiStatussptf,
  createSptfActionFail,
  createSptfDisable,
  getSptfRecoverySuccess,
  getSptfRecoveryFailure,
  updateSptfRecoveryFailure,
  updateSptfRecoverySuccess,
  deleteSptfRecoverySuccess,
  deleteSptfRecoveryFailure,
  searchFailure,
  searchSuccess,
} from "../../actions";
import CustomToast from "../../../components/Toast";

function* FactoryOwnerList(action) {
  try {
    const searchList = action.payload;
    const searchResults = yield call(
      axiosMain.post,
      `/admin/auctionCenter/dropdown/getUsersByAuctionCenter`,
      searchList
    );
    yield put(FactoryOwnerListActionSuccess(searchResults.data));
  } catch (error) {
    yield put(FactoryOwnerListActionFail(error));
  }
}

function* FactoryList(action) {
  try {
    const searchList = action.payload;
    const searchResults = yield call(
      axiosMain.post,
      `/admin/factory/search`,
      searchList
    );
    yield put(FactoryListActionSuccess(searchResults.data));
  } catch (error) {
    yield put(FactoryListActionFail(error));
  }
}

function* createSptfSaga(action) {
  try {
    const newSptfData = action.payload;
    const createdSptf = yield call(
      axiosMain.post,
      `/admin/sptfrecovery/create`,
      newSptfData
    );
    if (createdSptf.status == 200) {
      if (createdSptf.data.statusCode == 200) {
        CustomToast.success(createdSptf.data.message);
        yield put(createSptfActionSuccess(createdSptf));
        // yield put(getSptf(newSptfData.searchData));
        yield put(createEditApiStatussptf(true));
      } else {
        CustomToast.error(createdSptf.data.message);
        yield put(createSptfActionFail(createdSptf));
      }
    } else {
      CustomToast.error(createdSptf.data.message);
      yield put(createSptfActionFail(createdSptf.data.message));
    }
  } catch (error) {
    yield put(createSptfActionFail(error));
  }
  yield put(createSptfDisable(true));
}
function* getSptfRecovery(action) {
  try {
    // Make the GET request using Axios
    const response = yield call(axiosMain.get, `/admin/sptfrecovery/get/${action.payload}`);
    
    // Dispatch success action with the response data
    yield put(getSptfRecoverySuccess(response.data));
  } catch (error) {
    // Dispatch failure action with the error message
    yield put(getSptfRecoveryFailure(error.message));
  }
}
function* getAllSptf(action) {
  try {
    const { payload } = action;

    const response = yield call(axiosMain.post, `/admin/sptfrecovery/search`, payload);

    yield put(searchSuccess(response.data));
  } catch (error) {
  
    yield put(searchFailure(error.message));
  }
}

function* updateSptfRecovery(action) {
  try {
    const response = yield call(axiosMain.post, '/admin/sptfrecovery/update', action.payload);

    if (response.data.statusCode === 200) {
    yield put(updateSptfRecoverySuccess());

      CustomToast.success(response.data.message);
    }
    else{
      CustomToast.error(response.data.message);
      yield put(updateSptfRecoveryFailure())
    }

    // Dispatch success action
  } catch (error) {
    // Dispatch failure action with error
    yield put(updateSptfRecoveryFailure(error));
  }
}
// function* deleteSptfRecovery(action) {
//   try {
//     yield call(axiosMain.post, `/admin/sptfrecovery/delete/${action.payload}`);
//     yield put(deleteSptfRecoverySuccess());
//   } catch (error) {
//     yield put(deleteSptfRecoveryFailure(error));
//   }
// }
function* deleteSptfRecovery(action) {
  try {
    const response = yield call(axiosMain.post, `/admin/sptfrecovery/delete/${action.payload}`);
    
    if (response.data.statusCode === 200) {
      // Show success toast
      yield put(deleteSptfRecoverySuccess());
      CustomToast.success(response.data.message)
    } else {
      // Show error toast
      CustomToast.error(response.data.message)

      yield put(deleteSptfRecoveryFailure());
    }
  } catch (error) {
    // Show error toast
    // CustomToast.error(error)
    yield put(deleteSptfRecoveryFailure(error));
  }
}
export function* SptfSagas() {
  yield all([takeEvery(GET_SPTF_RECOVERY_REQUEST, getSptfRecovery)]);
  yield all([takeEvery(GET_ALL_FACTORY_OWNER, FactoryOwnerList)]);
  yield all([takeEvery(GET_ALL_FACTORY_LIST, FactoryList)]);
  yield all([takeEvery(GET_ALL_SPTF_CREATE, createSptfSaga)]);
  yield all([takeEvery(UPDATE_SPTF_RECOVERY_REQUEST, updateSptfRecovery)]);
  yield all([takeEvery(DELETE_SPTF_RECOVERY_REQUEST, deleteSptfRecovery)]);
  yield all([takeEvery(SEARCH_REQUEST, getAllSptf)]);
}
